import { I18N_KEYS } from '@/language/keys';
import type { GeneratorFailure } from '@/hooks/useGeneratorRuns';

export type RunErrorBanner = { title: string; message: string };

/** What the banner above the prompt says when some runs of a Generate failed. */
export function runErrorBanner(
  { failed, total }: GeneratorFailure,
  t: (key: string, options?: Record<string, unknown>) => string,
): RunErrorBanner {
  // only the server's own prompt check is caught here, a block by the provider during the run is a failed run
  if (failed.some((run) => run.promptBlocked)) {
    return {
      title: t(I18N_KEYS.GENERATE_PAGE.PROMPT_BLOCKED_TITLE),
      message: t(I18N_KEYS.GENERATE_PAGE.PROMPT_BLOCKED_MESSAGE),
    };
  }
  return {
    title: t(I18N_KEYS.GENERATE_PAGE.RUN_ERROR_TITLE),
    message:
      failed.length < total
        ? t(I18N_KEYS.GENERATE_PAGE.RUN_ERROR_SOME, { failed: failed.length, total })
        : (failed[0]?.error ?? t(I18N_KEYS.GENERATE_PAGE.RUN_ERROR_RETRY)),
  };
}
